module.exports = __webpack_public_path__ + "img/sms.524cfd7a.svg";